import Service, {parseParams} from 'api';

export const list = (params = {}, config) => {
  const parsedParams = parseParams({
    sort: 'order DESC,description',
    limit: 0,
    ...params,
  });

  return Service.get(`universities?${parsedParams}`, config);
};

export const post = (data = {}, config = {}) => Service.post('universities', data, config);
export const put = (id, data = {}, config = {}) => Service.put(`universities/${id}`, data, config);
export const destroy = (id, config) => Service.delete(`universities/${id}`, config);
